import React, { FC } from 'react'
import { Stack, Typography } from '@mui/material'

import { LoadingIndicator } from '@/apps/latest/components/atoms/LoadingIndicator'
import { PORTAL_TEXT } from '@/apps/latest/shared/styles/portalTypography'

// portal page の loading state 統一. Section 内 / page 全体どちらでも使える.
interface PageLoadingProps {
  /** 補助メッセージ (= 「読み込み中…」 等). 任意. */
  message?: string
  /** minHeight 上書き. default 240. */
  minHeight?: number
}

export const PageLoading: FC<PageLoadingProps> = ({
  message,
  minHeight = 240,
}) => (
  <Stack
    alignItems="center"
    justifyContent="center"
    gap={1.5}
    sx={{ minHeight, py: 4 }}
  >
    <LoadingIndicator />
    {message && <Typography sx={PORTAL_TEXT.caption}>{message}</Typography>}
  </Stack>
)
